import { IconType } from '../../../types/icon.type';
import { IconSize, TextColor } from '../../../types/text.type';
import { TextVariant } from '../../../types/v2/text';
import Icon from '../../icons/icon';
import { HStack } from '../../layouts/stack.layout';
import Text from './text';

type IconTextGroupProps = {
  icon: IconType;
  iconColor?: TextColor;
  iconSize?: IconSize;
  text: string;
  variant?: TextVariant;
  iconFirst?: boolean;
  gap?: 'xs' | 'sm' | 'base' | 'md' | 'lg' | 'xl';
};

export function IconTextGroup(props: IconTextGroupProps) {
  const { icon, text, iconFirst, variant, iconColor, gap } = props;

  return (
    <HStack
      rowReverse={!iconFirst}
      extensions="w-fit items-center"
      gap={gap || 'sm'}
    >
      <Icon size={props.iconSize || 'sm'} icon={icon} color={iconColor} />
      <Text variant={variant}>{text}</Text>
    </HStack>
  );
}
